
import { ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { property } from "lodash";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SpeakerSelector extends Vue {
  @Prop() speaker!: any;
  @Prop() personDataSource!: ListDataSource;
  @Prop({ default: "Не определено" }) notDefinedCaption!: string;
  @Prop() canEdit!: boolean;
  personId: any = null;

  editMode: boolean = false;

  get person() {
    return this.personDataSource.items.find(
      (i: any) => i.id === this.dataSource.model.personId,
    );
  }

  dataSource: ObjectDataSource = new ObjectDataSource({
    className: "EventSessionItemPerson",
    id: this.speaker.id,
    model: this.speaker,
    config: {},
  });

  async update(personId) {
    await this.dataSource.updateField({
      fieldName: "personId",
      fieldValue: personId,
    });
    this.editMode = false;
  }
}
